export class CargoDescuento {
    indicadorCargoDescuento: boolean;
    codigoCargoDescuento: string;
    factorCargoDescuento: number;
    montoCargoDescuento: number;
    montoBaseCargoDescuento: number;

    constructor(indicadorCargoDescuento: boolean = true,
                codigoCargoDescuento: string = '46',
                factorCargoDescuento: number = 0.00,
                montoCargoDescuento: number = 0.00,
                montoBaseCargoDescuento: number = 0.00
    ) {
        this.indicadorCargoDescuento = indicadorCargoDescuento;
        this.codigoCargoDescuento = codigoCargoDescuento;
        this.factorCargoDescuento = factorCargoDescuento;
        this.montoCargoDescuento = montoCargoDescuento;
        this.montoBaseCargoDescuento = montoBaseCargoDescuento;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/cargoDescuento.ts